import { Checkbox, DataSource, ExcludableTextbox, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutBrokerageRevenueReport extends Layout {
    checkboxAvailable: Checkbox;
    checkboxDelivered: Checkbox;
    checkboxInProgress: Checkbox;
    excludeabletextboxCarriers: ExcludableTextbox;
    excludeabletextboxControllingParties: ExcludableTextbox;
    excludeabletextboxCustomers: ExcludableTextbox;
    excludeabletextboxDispatchers: ExcludableTextbox;
    excludeabletextboxOrderTypes: ExcludableTextbox;
    excludeabletextboxRevenueCodes: ExcludableTextbox;
    excludeabletextboxSalespersons: ExcludableTextbox;
    excludeabletextboxSteamshipLines: ExcludableTextbox;
    labelOrderStatus: Label;
    panelOrderStatus: Panel;
    sourceBrokerageRevenue: DataSource;
    switchLTL: Switch;
    switchReportType: Switch;
    switchSecondarySort: Switch;
    textboxDateRange: Textbox;
    textboxDateType: Textbox;
    textboxGroupBy: Textbox;
    textboxIncludeContainer: Textbox;
}
